'use client';

import { useEffect, useRef, useState } from 'react';

import { ConversationViz } from './conversation-viz';

export function ConversationSection() {
  const [active, setActive] = useState(false);
  const ref = useRef<HTMLElement | null>(null);

  // IntersectionObserver to trigger animation
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setActive(true);
          io.unobserve(el); // Only trigger once
        }
      },
      { threshold: 0.35 } // Trigger when 35% visible
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section ref={ref} className="conversation-section container">
      <div className="conversation-text">
        <p className="eyebrow reveal">How it works</p>
        <h2 className="display h2 conversation-heading reveal d1">
          It starts with a <em className="italic sub">conversation</em>.
        </h2>
        <p className="lede reveal d2">
          No questionnaires. No blank pages. Just talk with Lori. She listens, follows the thread,
          and asks the questions that uncover stories you might never think to tell.
        </p>
      </div>

      <div className="conversation-viz-wrapper reveal d3">
        <ConversationViz active={active} />
      </div>
    </section>
  );
}
